<header class="header-auto header-blog">
    <div class="container-m">
       <div class="button-wrapper b-40px">
          <a [routerLink]="['/guides']" class="button-back-to text-background w-inline-block">
             <img src="../../assets/images/615ea8ddc2e6617d30a9925a_Gruppe%20811.svg" loading="lazy" width="16" alt="" class="image arrow-left"/>
             <div>Back to articles</div>
          </a>
       </div>
       <div class="content-wrapper b-10px">
          <div class="guides-publishing-content">
             <div class="blog-time-wrapper">
                <p class="text-blog text-background">{{blog.blogDate | date:'MMM dd, yyyy'}}</p>
             </div>
             <p class="text-blog text-background">•</p>
             <div class="blog-category-wrapper">
                <p class="text-blog text-primary"> {{blog.blogPlace}}</p>
             </div>
          </div>
       </div>
       <div class="content-wrapper">
          <div class="h2 text-background">{{blog.blogTitle}}</div>
       </div>
    </div>
    <div class="bg-section bg-dark"><img src="../../assets/images/615ea8ddc2e661d2b0a9925c_Gruppe%20maskieren%2089.svg" loading="lazy" alt="" class="image full-screen fit-top"/></div>
 </header>
 <section class="section standard t-0px">
    <div class="container-m"><img alt="" loading="lazy" width="1267" src="{{blog.mediaUri}}" class="image title-image"/></div>
    <div class="bg-section bg-background">
       <div class="bg-section-inner h-40p bg-dark bg-rounded-bottom"></div>
    </div>
 </section>
 <section class="section standard t-0px">
    <div class="container-s">
       <div class="w-richtext" [innerHTML]="blog.blogDetail">
          
       </div>
       <div class="line space-50px"></div>
       <div class="orga-blog-wrapper">
          <div class="w-layout-grid grid _2er-guides-social">
             <div id="w-node-_2de22599-c884-687e-8a7c-4703541f67f4-11a9927c" class="grid-item">
                <a [routerLink]="['/guides']" class="button-back w-inline-block">
                   <img src="../../assets/images/615ea8ddc2e66181a2a9925b_Gruppe%20811.svg" loading="lazy" width="13" alt="" class="icon-arrow-s back-blog"/>
                   <div>Back to all</div>
                </a>
             </div>
             <!-- <div id="w-node-_2de22599-c884-687e-8a7c-4703541f67f9-11a9927c" class="grid-item">
                <div class="social-wrapper">
                   <div class="text-caps">Share</div>
                   <a href="#" class="social-button l-15px w-inline-block"><img src="https://cdn.prod.website-files.com/615ea8ddc2e6613b8da991ea/615ea8ddc2e661a1dba99219_Facebook.svg" loading="lazy" alt="" class="social-icon"/></a><a href="#" class="social-button w-inline-block"><img src="https://cdn.prod.website-files.com/615ea8ddc2e6613b8da991ea/615ea8ddc2e6619bd0a9921c_Twitter.svg" loading="lazy" width="31" alt="" class="social-icon"/></a><a href="#" class="social-button w-inline-block"><img src="https://cdn.prod.website-files.com/615ea8ddc2e6613b8da991ea/615ea8ddc2e6610c79a9921a_Vector.svg" loading="lazy" width="31" alt="" class="social-icon"/></a>
                </div>
             </div> -->
          </div>
       </div>
    </div>
    <div class="bg-section bg-background"></div>
 </section>
 <section class="section standard" *ngIf="blog.otherBlogs.length > 0">
    <div class="container-m">
       <div class="content-wrapper max-60p l-center">
          <div data-w-id="29cf4731-93bf-cfa5-564c-e588c7922f10"  class="topline-wrapper b-30px c-center">
             <div class="text-topline">More Guides</div>
             <div class="topline-line bg-primary c-center"></div>
          </div>
          <h4 data-w-id="a40d4ae2-2d5a-ee3e-b96a-827072b015bd"  class="h2 l-center">Further reading</h4>
       </div>
       <div class="collection-list-wrapper t-40px w-dyn-list">
          <div role="list" class="collection-grid _3er-blog w-dyn-items">
            <div *ngFor="let guide of blog.otherBlogs" role="listitem" class="collection-item w-dyn-item">
                <a  [routerLink]="['/guide', guide.id]" class="collection-link blog-link w-inline-block">
                  <div class="image-wrapper h-250px overflow-hidden-blog"><img src="{{guide.mediaUri}}" loading="lazy" alt="" class="image full-screen"></div>
                  <div class="box blog-normal">
                    <div class="orga">
                      <div class="box-inner-02">
                        <div class="blog-wrapper b-20px">
                          <div class="properties-content">
                            <div class="blog-time-wrapper">
                              <p class="text-blog text-default">{{guide.blogDate | date:'MMM dd, yyyy'}}</p>
                            </div>
                            <p class="text-blog text-default">•</p>
                            <div class="blog-category-wrapper">
                              <p class="text-blog text-primary">{{guide.blogPlace}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="box-inner-01">
                        <h5 class="h5 blog-h">{{guide.blogTitle}}</h5>
                      </div>
                    </div>
                    <div class="button-wrapper t-blog">
                      <div class="button button-primary">
                        <div>Read more</div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
          </div>
       </div>
    </div>
    <div class="bg-section bg-light"></div>
 </section>
 <section class="section standard t-0px">
    <div data-w-id="ca13da15-9f73-5f9d-ef11-897b462276d0" class="container-box bg-dark">
       <div class="container-m">
          <div class="content-wrapper max-80p l-center">
             <h4 data-w-id="ca13da15-9f73-5f9d-ef11-897b462276d3" class="h2 l-center">Get in <span class="text-span">Touch</span></h4>
             <div class="content-wrapper max-80p l-center">
                <p data-w-id="39b339fb-9475-0589-4802-a037d65bbffd" class="text-normal l-center text-background">Contact our real estate experts to discuss your needs. Our team has the expertise to guide you through the entire process.<br/></p>
             </div>
             <div data-w-id="bf7d05b6-ff9e-5077-5aa2-00ecb948f821" class="button-wrapper l-center t-30px">
                <a [routerLink]="['/buy-properties']" class="button button-primary r-25px w-button">Property to buy</a>
                <div class="button-wrapper-inner xs-t-20px"><a href="tel:+97145693115" class="button button-link button-line w-button">+971 4 380 5710</a></div>
             </div>
          </div>
       </div>
       <img src="../../assets/images/615ea8ddc2e6614f19a99240_Gruppe%20maskieren%2078.svg" loading="lazy" alt="" class="image full-screen"/>
    </div>
    <div class="bg-section bg-light"></div>
 </section>